import React from "react";
import EconomicTable from "../EconomicTable";
import { useMarketInternalsData } from "../../../context/MarketInternalsContext";

const RatesPricingTab = () => {
    const { filteredRows: rows } = useMarketInternalsData();

    const data = rows.filter(row => row.Category === "RATES_PRICING");

    return <EconomicTable
        data={data}
        title="Rates Pricing"
        defaultRowData={{ Category: "RATES_PRICING", Topic: "Fed Watch" }}
        groupBy="Topic"
        groupOrder={["Fed Watch", "Central Bank Expectations"]}
        useDataHook={useMarketInternalsData}
    />;
};

export default RatesPricingTab;
